import css from 'styled-jsx/css';

export default css`
  .CuralateEmbed {
    margin: 1em;
  }
`;
